
import {
    LIST_OPERATION_ACTION_TYPE
} from '../sagas/list';

import {
    GET_PROJECT_ACTION_TYPE,
    REFRESH_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    actualList: null,
    actualListName: null
};

function getActualList(state, data) {
    let actualListName = getActualListName(state, data);
    return actualListName
        ? data.reduce((previous, current) => {
            return (current.name === actualListName)
                ? current
                : previous;
        }, null)
        : null;
}

function getActualListName(state, data) {
    return state.actualListName
        ? state.actualListName
        : getFirstListName(data);
}

function getFirstListName(data) {
    return (data.length > 0)
        ? data[0].name
        : null;
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(LIST_OPERATION_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case LIST_OPERATION_ACTION_TYPE.SUCCESS:
                return {
                    ...loaderReducer(state, action),
                    actualList: getActualList(state, action.data.result.list),
                    actualListName: getActualListName(state, action.data.result.list)
                };

            case REFRESH_PROJECT_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
